// Shared backend client for the EcoCupid community project.
//
// This site intentionally talks to the SAME backend as the EcoCupid Media
// community site so that blogs, YouTube videos and map projects are shared
// between both sites. All content is managed from the community site itself;
// this site is a read-only media showcase. The URL and publishable (anon) key
// below are public values and safe to commit.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = 'https://zxhbywivfwybzjoufslp.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp4aGJ5d2l2Znd5Ynpqb3Vmc2xwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg3MjgzMTMsImV4cCI6MjA4NDMwNDMxM30.tNlPOndRDkIX3y9-sD9RqeckiCT9QZQu8eiKVDktKf4';

// Import the shared backend client like this:
// import { supabase } from "@/integrations/community/client";
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
